<p-messages [(value)]="msgs"></p-messages>
<div class="p-grid">
    <div class="col-12 p-md-12 p-lg-12" *ngIf="cargandoDataInit">
        <div class="card">
            <h4>{{appConfig.ux.loadingMsg}}</h4>
            <p-progressBar mode="indeterminate"></p-progressBar> 
        </div>
    </div>
    <div class="col-12 p-md-12 p-lg-12" *ngIf="!cargandoDataInit">
        <div class="card p-p-4">
            <form #retencionEditorForm="ngForm" 
                  (ngSubmit)="confirmarRetencion($event);"
                  [ngClass]="{'disabledForm': retencion && retencion.internalStatus && retencion.internalStatus == 'POSTED'}"><!-- retencionEditorForm.reset();-->
                <div class="p-fluid p-formgrid grid">
                    <div class="p-field col-12">
                        <h2 class="uppercase">{{ appConfig.app.name }}  {{ retencion.secuencial ?  '|' : '' }} {{ retencion.secuencial ?  retencion.secuencial : '' }}</h2>
                    </div>
                    <div class="p-field col-12 md:col-12 mb-0">
                        <div class="font-bold text-bluegray-500 bg-bluegray-100 p-2 mx-0 uppercase border-round-top">{{'Datos del Proveedor'}}</div>
                        <div class="bg-bluegray-50 p-2 mx-0 border-round-bottom"   style="min-height: 91%">
                            <div class="p-field col-12"
                                 *ngIf="retencion && retencion.claveAcceso">
                                <i class="pi pi-key"></i><span>{{ retencion.claveAcceso }}</span>
                            </div>
                            <div class="p-p-field col-12">
                                <p-button styleClass="p-button-raised p-button-text p-button-success"
                                          (click)="activePopupSubjectCustomers($event)"
                                          [disabled]="(retencion && retencion.secuencial)">
                                    <ng-template pTemplate="content">
                                        <div class="p-field col-12 mb-0">
                                            <div class="flex align-items-center justify-content-between">
                                                {{ subjectCustomer.id ? subjectCustomer.customerFullName : 'Cliente...'}}
                                                / {{ subjectCustomer.id ? subjectCustomer.customerCode : 'CI/RUC...'}}
                                                <i class="pi pi-user-edit required-icon"></i>
                                            </div>
                                        </div>
                                    </ng-template>
                                </p-button>
                            </div>
                            <div class="p-field col-12" *ngIf="subjectCustomer && subjectCustomer.id">
                                <label for="direccion">Dirección</label>
                                <textarea #direccion="ngModel" id="direccion" name="direccion" type="text"
                                          [(ngModel)]="retencion.direccion" 
                                          [pattern]="appConfig['validationRegExp']['safeMultilineTextPattern']"
                                          placeholder="Dirección del cliente"
                                          [rows]="2"
                                          [maxlength]="256"
                                          [disabled]="false"
                                          [required]='true'
                                          pInputTextarea></textarea>
                                <p-message severity="error" [text]="appConfig['validationMsgs']['safeMultilineTextPattern']" 
                                           *ngIf="retencionEditorForm.controls['direccion'] 
                                           && !retencionEditorForm.controls['direccion'].valid 
                                           && (retencionEditorForm.controls['direccion'].dirty 
                                           || retencionEditorForm.controls['direccion'].touched)">
                                </p-message>
                            </div>
                            <div class="p-field col-12" *ngIf="!retencion || (subjectCustomer && subjectCustomer.id)">
                                <label for="destinatarios">Notificar a: </label><span class="required-asterisk mr-2">*</span>
                                <mat-form-field id="destinatarios" class="chip-list" appearance="fill">
                                    <mat-label>(Presione enter, espacio, escape o coma, para separar destinatarios)</mat-label>
                                    <mat-chip-list #chipList aria-label="Selección de destinatarios">
                                        <mat-chip
                                            *ngFor="let destinatario of destinatarios"
                                            (removed)="removerDestinatario(destinatario)">
                                            {{destinatario}}
                                            <button matChipRemove>
                                                <mat-icon>cancel</mat-icon>
                                            </button>
                                        </mat-chip>
                                        <input
                                            placeholder="Agregar..."
                                            #destinatarioInput
                                            [formControl]="destinatarioCtrl"
                                            [matAutocomplete]="auto"
                                            [matChipInputFor]="chipList"
                                            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                                            (matChipInputTokenEnd)="agregarDestinatario($event)"
                                            [matChipInputAddOnBlur]="false"
                                            (blur)="agregarDestinatarioBlur($event)">
                                    </mat-chip-list>
                                    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectedDestinatario($event)">
                                        <mat-option *ngFor="let destinatario of filtered | async" [value]="destinatario">
                                            {{destinatario}}
                                        </mat-option>
                                    </mat-autocomplete>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                    <div class="p-field col-12">
                        <div class="font-bold text-bluegray-500 bg-bluegray-100 p-2 mx-0 uppercase border-round-top">Detalles de retención</div>
                        <div class="p-field col-12"
                             *ngIf="true">
                            <p-button styleClass="p-button-outlined p-button-info"
                                      (click)="mostrarRetencionDetalle($event)"
                                      [disabled]="retencion && retencion.secuencial">
                                <ng-template pTemplate="content">
                                    <div class="p-field col-12 mb-0">
                                        <div class="flex align-items-center justify-content-between">
                                            {{'Nuevo detalle'}}
                                            <i class="pi pi-plus required-icon"></i>
                                        </div>
                                    </div>  
                                </ng-template>
                            </p-button>
                        </div>
                        <div class="p-field col-12 mb-0">
                            <div id="invoice-content">
                                <div class="invoice p-0">
                                    <div *ngIf="details.length > 0" 
                                         class="invoice-items p-0 m-1">
                                        <p-table [value]="details" dataKey="id" responsiveLayout="scroll">
                                            <ng-template pTemplate="header">
                                                <tr>
                                                    <th> {{'Tipo de retención'}} </th>
                                                    <th> {{'Código de retención'}} </th>
                                                    <th> {{'% retención'}} </th>
                                                    <th> {{'Tipo documento sustento'}} </th>
                                                    <th> {{'Número documento sustento'}} </th>
                                                    <th> {{'Fecha de emisión documento sustento'}} </th>
                                                    <th> {{'Base imponible'}} </th>
                                                    <th> {{'Monto retenido'}} </th>
                                                    <th> {{'Acciones'}} </th>
                                                </tr>
                                            </ng-template>
                                            <ng-template pTemplate="body" let-detail>
                                                <tr>    
                                                    <td>
                                                        {{ detail.tipoImpuesto?.description }}
                                                    </td>
                                                    <td>
                                                        {{ detail.retencion?.code }} {{ detail.retencion?.description }}
                                                    </td>
                                                    <td>
                                                        {{ detail?.porcentaRetencion }}
                                                    </td>
                                                    <td>
                                                        {{ detail.tipoComprobante?.description }}
                                                    </td>
                                                    <td>
                                                        {{ detail.numeroDocumentoSustento }}
                                                    </td>
                                                    <td>
                                                         {{detail.fechaEmisionDocumentoSustento | date: 'MM/dd/yyyy'}}
                                                    </td>
                                                    <td>
                                                        {{ detail.baseImponible | number:'1.0-3' }}
                                                    </td>
                                                    <td>
                                                        {{ detail.montoRetenido | number:'1.0-3' }}
                                                    </td>
                                                    <td>
                                                        <p-button  icon="pi pi-delete-left" 
                                                            label="Remover"
                                                            (click)="removerDetalle(detail.indice)"
                                                            *ngIf="detail.indice"></p-button>
                                                    </td>
                                            </ng-template>
                                        </p-table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="p-field col-12 mb-0">
                        <app-establecimientos [puntoEmisionSeleccionado]="emissionPointSelected"
                                              [establecimientos]="establishments"
                                              (onChange)="asignarPuntoEmision($event)"
                                              [requerido]="true"></app-establecimientos>
                    </div>
                </div>
                <p-footer>
                    <div class="flex align-items-center justify-content-end">
                        <button pButton pRipple
                                type="button" 
                                label="{{appConfig.ux.actions.cancel}}"
                                icon="pi pi-times" class="p-button-secondary"
                                (click)="fazilService.irAInicioRetenciones()">
                        </button>
                        <button  pButton pRipple
                                 type="submit" 
                                 label="{{appConfig.ux.actions.emitir}}"
                                 icon="pi pi-send" class="ml-1"
                                 [disabled]="(!retencionEditorForm.valid
                                 || !exitenDetallesSeleccionados
                                 || (!subjectCustomer || !subjectCustomer.customerId)
                                 || (!emissionPointSelected || !emissionPointSelected.id)
                                 || !destinatarios)">
                        </button>
                    </div>
                </p-footer>
            </form>
        </div>
    </div>
</div>
<p-messages [(value)]="msgs"></p-messages>

<!-- Buscador de contactos -->
<app-contacto-buscador
    [currentUser] ="currentUser"
    [mostrarBuscador] = "mostrarPopupSubjectCustomers"
    [estaCargandoDatos] = "false"
    (contactoSeleccionado) = "handleContactoSeleccionado($event);"
    ></app-contacto-buscador>

<!-- Buscador de productos -->

<!---Diálogo agregar/editar retención--->
<p-dialog [(visible)]="mostrarPopupDetalleRetencion" 
          modal="modal" showEffect="fade" 
          [breakpoints]="{'960px': '75vw', '640px': '100vw'}" 
          [style]="{width: '75vw', height: '700px'}"
          (onHide)="mostrarPopupDetalleRetencion=false;"    
          [closable]="true"
          styleClass="p-dialog-product">
    <ng-template pTemplate="header">
        <div class="surface-section px-2 md:px-3 lg:px-4 text-center flex-auto">
            <div class="mb-3 font-bold text-2xl">
                <span class="text-900">¡Atención!, </span>
                <span class="text-blue-600">Verifique los datos de los comprobantes para aplicar las retenciones</span>
            </div>
        </div>
    </ng-template>
    <ng-template pTemplate="content">
        <div id="contentPanel" class="surface-section px-2 md:px-3 lg:px-4">
            <form
                #retencionDetalleForm="ngForm"
                (ngSubmit)="agregarDetalle()"
                [ngClass]="{ disabledForm: false }">
                <p-messages [(value)]="msgs"></p-messages>
                <div class="p-fluid p-formgrid grid">
                    <div class="p-field col-12 md:col-3">
                        <label for="tipoImpuesto">Tipo de retención</label>
                        <p-dropdown
                            #tipoImpuesto="ngModel"
                            id="tipoImpuesto"
                            [options]="tiposRetenciones"
                            [(ngModel)]="detail.tipoImpuesto"
                            [ngModelOptions]="{standalone: true}"
                            optionLabel="description"
                            [filter]="true"
                            filterBy="description"
                            [showClear]="true"
                            required>
                            <ng-template pTemplate="selectedItem">
                                <div class="country-item country-item-value" *ngIf="detail.tipoImpuesto">
                                    <div>{{ detail.tipoImpuesto.description ? detail.tipoImpuesto.description : 'Selecione un tipo de impuesto...'}}</div>
                                </div>
                            </ng-template>
                            <ng-template let-tipoImpuesto pTemplate="item">
                                <div class="country-item">
                                    <div>{{ tipoImpuesto?.description }}</div>
                                </div>
                            </ng-template>
                        </p-dropdown>
                        <p-message
                            severity="error"
                            [text]="appConfig['validationMsgs']['selectRequired']"
                            *ngIf="retencionDetalleForm.controls['tipoImpuesto'] &&
                            !retencionDetalleForm.controls['tipoImpuesto'].valid &&
                            (retencionDetalleForm.controls['tipoImpuesto'].dirty ||
                            retencionDetalleForm.controls['tipoImpuesto'].touched)">
                        </p-message>
                    </div>
                    <div class="p-field col-12 md:col-9">
                        <label for="retencion">Código de retención</label>
                        <p-dropdown
                            #retencion="ngModel"
                            id="retencion"
                            name="retencion" 
                            [options]="retenciones"
                            [(ngModel)]="detail.retencion"
                            [ngModelOptions]="{standalone: true}"
                            optionLabel="description"
                            [filter]="true"
                            filterBy="code,description"
                            [showClear]="true"
                            (onChange)="actualizarPorcentajeRetencion($event)"
                            [virtualScroll]="true"
                            required>
                            <ng-template pTemplate="selectedItem">
                                <div class="country-item country-item-value" *ngIf="detail.retencion">
                                    <div>{{ detail.retencion.description ? detail.retencion?.code + ' ' + detail.retencion.description : 'Selecione un tipo de impuesto...'}}</div>
                                </div>
                            </ng-template>
                            <ng-template let-retencion pTemplate="item">
                                <div class="country-item">
                                    <div>{{retencion?.code}} {{ retencion?.description }}</div>
                                </div>
                            </ng-template>
                        </p-dropdown>
                        <p-message
                            severity="error"
                            [text]="appConfig['validationMsgs']['selectRequired']"
                            *ngIf="retencionDetalleForm.controls['retencion'] &&
                            !retencionDetalleForm.controls['retencion'].valid &&
                            (retencionDetalleForm.controls['retencion'].dirty ||
                            retencionDetalleForm.controls['retencion'].touched)">
                        </p-message>
                    </div>
                    <div class="p-field col-12 md:col-12">
                        <label for="retencion">Porcentaje de retención</label>
                        <p-inputNumber 
                            #porcentajeRetencion="ngModel" 
                            id="porcentajeRetencion" 
                            name="porcentajeRetencion" 
                            [(ngModel)]="detail.porcentaRetencion"
                            placeholder="{{appConfig.ux.undefinedNumber}}"
                            [showButtons]="true"
                            [min]="0" [minFractionDigits]="2" [maxFractionDigits]="2"
                            required
                            (onBlur)="calcularMontoRetenido($event)">
                        </p-inputNumber>
                        <p-message
                            severity="error"
                            [text]="appConfig['validationMsgs']['numberPattern']"
                            *ngIf="retencionDetalleForm.controls['porcentajeRetencion'] &&
                            !retencionDetalleForm.controls['porcentajeRetencion'].valid &&
                            (retencionDetalleForm.controls['porcentajeRetencion'].dirty ||
                            retencionDetalleForm.controls['porcentajeRetencion'].touched)">
                        </p-message>
                    </div>
                    <div class="p-field col-12 md:col-4">
                        <label for="tipoComprobante">Tipo documento sustento</label>
                        <p-dropdown
                            id="tipoComprobante"
                            name="tipoComprobante" 
                            [options]="tiposComprobantes"
                            [(ngModel)]="detail.tipoComprobante"
                            [ngModelOptions]="{standalone: true}"
                            optionLabel="description"
                            [filter]="true"
                            filterBy="description"
                            [showClear]="true"
                            required>
                            <ng-template pTemplate="selectedItem">
                                <div class="country-item country-item-value" *ngIf="detail.tipoComprobante">
                                    <div>{{ detail.tipoComprobante.description ? detail.tipoComprobante.description : 'Selecione un tipo de comprobante...'}}</div>
                                </div>
                            </ng-template>
                            <ng-template let-tipoDocumento pTemplate="item">
                                <div class="country-item">
                                    <div>{{ tipoDocumento?.description }}</div>
                                </div>
                            </ng-template>
                        </p-dropdown>
                    </div>
                    <div class="p-field col-12 md:col-4">
                        <label for="numeroDocumentoSustento">Número de documento sustento</label>
                        <p-inputMask
                            #numeroDocumentoSustento="ngModel"
                            id="numeroDocumentoSustento"
                            name="numeroDocumentoSustento" 
                            [(ngModel)]="detail.numeroDocumentoSustento" 
                            [ngModelOptions]="{standalone: true}"
                            mask="999-999-999999999"
                            placeholder="Ej.: 001-001-00000001"
                            required></p-inputMask>
                        <p-message
                            severity="error"
                            [text]="appConfig['validationMsgs']['codigoPattern']"
                            *ngIf="retencionDetalleForm.controls['numeroDocumentoSustento'] &&
                            !retencionDetalleForm.controls['numeroDocumentoSustento'].valid &&
                            (retencionDetalleForm.controls['numeroDocumentoSustento'].dirty ||
                            retencionDetalleForm.controls['numeroDocumentoSustento'].touched)">
                        </p-message>
                    </div>
                    <div class="p-field col-12 md:col-4">
                        <label for="fechaEmisionDocumentoSustento">Fecha de emisión documento sustento</label>
                        <p-calendar 
                            #fechaEmisionDocumentoSustento="ngModel"
                            id="fechaEmisionDocumentoSustento"
                            name="fechaEmisionDocumentoSustento"
                            [(ngModel)]="detail.fechaEmisionDocumentoSustento"
                            [ngModelOptions]="{standalone: true}"
                            [required]="true"
                            [[style]="{'position': 'fixed', 'overflow': 'visible', 'z-index': '999'}" [showIcon]="true" inputId="icon"
                            [maxDate]="fechaActual">
                        </p-calendar>
                        <p-message
                            severity="error"
                            [text]="appConfig['validationMsgs']['dateInvalid']"
                            *ngIf="retencionDetalleForm.controls['fechaEmisionDocumentoSustento'] &&
                            !retencionDetalleForm.controls['fechaEmisionDocumentoSustento'].valid &&
                            (retencionDetalleForm.controls['fechaEmisionDocumentoSustento'].dirty ||
                            retencionDetalleForm.controls['fechaEmisionDocumentoSustento'].touched)">
                        </p-message>
                    </div>
                    <div class="p-field col-12 md:col-12">
                        <label for="retencion">Base imponible</label>
                        <p-inputNumber 
                            #baseImponible="ngModel" 
                            id="baseImponible" 
                            name="baseImponible" 
                            [(ngModel)]="detail.baseImponible"
                            placeholder="{{appConfig.ux.undefinedNumber}}"
                            [showButtons]="true"
                            [min]="0" [minFractionDigits]="2" [maxFractionDigits]="2"
                            required
                            (onBlur)="calcularMontoRetenido($event)">
                        </p-inputNumber>
                        <p-message
                            severity="error"
                            [text]="appConfig['validationMsgs']['numberPattern']"
                            *ngIf="retencionDetalleForm.controls['baseImponible'] &&
                            !retencionDetalleForm.controls['baseImponible'].valid &&
                            (retencionDetalleForm.controls['baseImponible'].dirty ||
                            retencionDetalleForm.controls['baseImponible'].touched)">
                        </p-message>
                    </div>
                    <div class="p-field col-12 md:col-12">
                        <label for="retencion">Monto retenido</label>
                        <p-inputNumber 
                            #montoRetenido="ngModel" 
                            id="montoRetenido" 
                            name="montoRetenido" 
                            [(ngModel)]="detail.montoRetenido"
                            placeholder="{{appConfig.ux.undefinedNumber}}"
                            [showButtons]="true"
                            [min]="0" [minFractionDigits]="2" [maxFractionDigits]="2"
                            [disabled]="true">
                        </p-inputNumber>
                        <p-message
                            severity="error"
                            [text]="appConfig['validationMsgs']['numberPattern']"
                            *ngIf="retencionDetalleForm.controls['montoRetenido'] &&
                            !retencionDetalleForm.controls['montoRetenido'].valid &&
                            (retencionDetalleForm.controls['montoRetenido'].dirty ||
                            retencionDetalleForm.controls['montoRetenido'].touched)">
                        </p-message>
                    </div>
                </div>
                <p-footer>
                    <div class="flex align-items-center justify-content-end">
                        <button
                            pButton pRipple
                            type="button"
                            label="{{ appConfig.ux.actions.cancel }}"
                            icon="pi pi-times" class="p-button-secondary"
                            (click)="mostrarPopupDetalleRetencion = false">
                        </button>
                        <button
                            pButton pRipple
                            type="submit"
                            label="{{ appConfig.ux.actions.save }}"
                            icon="pi pi-check" class="ml-1"
                            [disabled]="(!retencionDetalleForm.valid)">
                        </button>
                    </div>
                </p-footer>
            </form>
        </div>
    </ng-template>
</p-dialog>
<!---------------------------------------------->
<!------Ventanas de confirmaciones modales------>
<!---------------------------------------------->
<p-confirmDialog #cd 
                 header="{{appConfig.ux.confirmMsg}}" 
                 icon="pi pi-exclamation-triangle">
    <ng-template pTemplate="footer">
        <button pButton pRipple
                type="button" 
                label="{{appConfig.ux.confirmFalse}}"
                icon="pi pi-times" class="p-button-secondary"
                (click)="cd.reject()">
        </button>
        <button pButton pRipple
                type="button" 
                label="{{appConfig.ux.confirmTrue}}"
                icon="pi pi-check" class="ml-1"
                (click)="cd.accept()">
        </button>
    </ng-template>
</p-confirmDialog>
<!--Ventana de espera de procesamiento-->
<p-dialog [(visible)]="procesando" 
          modal="modal" showEffect="fade" 
          [breakpoints]="{ '960px': '90vw', '640px': '100vw' }"
          [style]="{ width: '90vw' }"
          (onHide)="procesando=false;">
    <ng-template pTemplate="header">
        <h4>{{appConfig.ux.loadingMsg}}</h4>
    </ng-template>
    <ng-template pTemplate="content">
        <p-progressBar mode="indeterminate"></p-progressBar> 
    </ng-template>
    <ng-template pTemplate="footer">
        <span class="uppercase">{{appConfig.app.name}}</span>
    </ng-template>
</p-dialog>
<!--Ventana de resultData-->
<p-dialog [(visible)]="mostrarResultData" 
          modal="modal" showEffect="fade" 
          [breakpoints]="{ '960px': '25vw', '640px': '35vw' }" 
          [style]="{ width: '25vw' }"
          (onHide)="mostrarResultData=false;">
    <ng-template pTemplate="header">
        <h4>{{resultData['header']}}</h4>
    </ng-template>
    <ng-template pTemplate="content">
        <p-messages severity="{{resultData['type']}}">
            <ng-template pTemplate>
                <div class="ml-2">{{resultData['body']}}</div>
            </ng-template>
        </p-messages>

        <p-panel header="Detalle de errores" [toggleable]="true" [collapsed]="true" *ngIf="resultData['subErrors'] && resultData['subErrors'].length > 0">
            <p-messages severity="info" *ngFor="let subError of resultData['subErrors']">
                <ng-template pTemplate>
                    <div class="ml-2">{{subError.field}} | {{subError.rejectedValue}} | {{subError.message}}</div>
                </ng-template>
            </p-messages>
        </p-panel>
    </ng-template>
    <ng-template pTemplate="footer">
        <div class="flex align-items-center justify-content-center">
            <button *ngFor="let item of resultDataButtons let i = index" 
                    pButton pRipple
                    type="button" 
                    [label]="item.text"
                    [icon]="item.icon"
                    [class]="item.cssClass"
                    (click)="ejecutarAccionResult($event, item.action, null)"
                    [disabled]="item.disabled">
            </button>
        </div>
    </ng-template>
</p-dialog>
<!--Ventana de espera de verificacion-->
<p-dialog [(visible)]="verificando"
          modal="modal" showEffect="fade"
          [breakpoints]="{ '960px': '15vw', '640px': '20vw' }" 
          [style]="{ width: '15vw' }"
          [closable]="false"
          (onHide)="verificando = false"
          class="text-center">
    <ng-template pTemplate="header">
    </ng-template>
    <ng-template pTemplate="content">
        <h6>{{verificandoData['body']}}</h6>
        <i class="pi pi-spin pi-spinner text-orange-400 text-8xl"></i>
    </ng-template>
    <ng-template pTemplate="footer">
        <span class="p-text-uppercase">{{ appConfig.app.name }}</span>
    </ng-template>
</p-dialog>